module.exports = __webpack_public_path__ + "img/about.a23a0108.png";